import { t } from '@trimble/i18n';
import { formatDate } from '@trimble/utilities';
import { createMemo, For, JSX } from 'solid-js';

export interface UserCommentsProps {
  comments: UserComment[];
}

export interface UserComment {
  id: string;
  description: string;
  objectId: string;
  createdOn: string;
  createdBy: string;
  modifiedOn: string;
  modifiedBy: string;
  hasAttachment: boolean;
  contextId: string;
}

export const UserComments = (props: UserCommentsProps): JSX.Element => {
  const commentsLabel = createMemo((): string => {
    const label = t('shared.ui.userComments.comments');
    const userComments = props.comments;

    if (userComments.length === 0) return label;

    return `${label} (${userComments.length.toString()})`;
  });

  return (
    <div class="flex flex-col">
      <div class="h5 p-3 pb-0">{commentsLabel()}</div>
      <For each={props.comments}>
        {(comment, index) => (
          <div class={index() === 0 ? '' : 'border-t border-[#d0d0d7]'}>
            <div class="p-3">
              <div class="px-1 pb-1">
                {comment.createdBy}
                <div class="text-xs text-gray-6">
                  {formatDate(comment.createdOn)}
                </div>
              </div>
              {comment.description}
            </div>
          </div>
        )}
      </For>
    </div>
  );
};
